var map = {
	"./blackGold/footer/setting_user.png": 24181,
	"./brownGold/footer/setting_user.png": 32140,
	"./darkBlue/footer/setting_user.png": 45454,
	"./greenYellow/footer/setting_user.png": 72066,
	"./redGold/footer/setting_user.png": 86670,
	"./skyBlue/footer/setting_user.png": 52548,
	"./whiteGold/footer/setting_user.png": 22089,
	"./yellowWhite/footer/setting_user.png": 25069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46323;